import _ from 'lodash'

export default {
  data () {
    return {
      mappingsData: [],
      mappingsKeys: [],
      showEditMapping: false,
      editShape: null
    }
  },
  computed: {
    creatingShape () {
      if (this.tempLayer) {
        return this.tempLayer.children.filter(function (shape) {
          return shape.attrs.edit_type === 'creating'
        })[0]
      }
    }
  },
  methods: {
    updateMappingData () {
      let treeData = []
      treeData.push(this.formTreeData(this.drawLayer))
      this.mappingsData = treeData
      this.sortMappingData(this.mappingsData[0])
      this.mappingsKeys = this.tmpMappingsKeys([], treeData[0])
    },

    sortMappingData (mappingData) {
      mappingData.children.sort((a, b) => a.order - b.order)
      mappingData.children.map(child => {
        if (child.children) {
          this.sortMappingData(child)
        }
      })
    },

    formTreeData (node) {
      let prop = {
        id: node.attrs.path,
        title: this.formatTitle(node.attrs.key),
        expanded: true,
        order: node.attrs.order,
        type: node.nodeType,
        data_type: node.attrs.dataType,
        x: node.attrs.x,
        y: node.attrs.y,
        date_format: node.attrs.dateFormat,
        required: (node.attrs.required !== undefined && node.attrs.required === true)
      }
      if (node.children) {
        // create a relation between parent type and child
        // to detech whether to sort by x coordinate / y coordinate
        node.children.forEach(function (child) {
          child.attrs.parentDataType = node.attrs.dataType
          child.attrs.parentKey = node.attrs.key
        })

        let children = this.formChildNode(node.children)
        if (this.sortByX(node)) {
          prop.children = _.sortBy(children, 'x')
        } else {
          prop.children = _.sortBy(children, 'y')
        }
      }
      return prop
    },

    sortByX (node) {
      if (node.attrs.dataType === 'table_column' ||
          (node.attrs.dataType === 'table_header' && node.attrs.parentDataType === 'table_row') ||
            (node.attrs.dataType === 'table_entry' && node.attrs.parentDataType === 'table_row')) {
        return true
      } else {
        return false
      }
    },

    formChildNode (children) {
      let childProps = []

      children.forEach((child) => {
        if (child.attrs.map_type === 'group_holder') { return }
        childProps.push(this.formTreeData(child))
      })
      return childProps
    },

    formatTitle (title) {
      return title.charAt(0).toUpperCase() + title.slice(1)
    },

    tmpMappingsKeys (keys, parent) {
      if (parent.type !== 'Layer') {
        keys.push(parent.title.toLowerCase().replace(/\s/g, ''))
      }
      if (parent.children) {
        parent.children.forEach((child) => {
          keys = this.tmpMappingsKeys(keys, child)
        })
      }
      return keys
    },

    selectedShape (path, type) {
      return this.drawLayer.find(type).filter(function (shape) {
        return shape.attrs.path === path
      })[0]
    },

    mappingCreated (mappingData) {
      let newShape = this.creatingShape
      let parentPath = this.drawLayer.attrs.path
      newShape.setAttrs({
        id: 'created',
        key: mappingData.key,
        x_pos: newShape.attrs.x,
        y_pos: newShape.attrs.y,
        map_type: 'shape',
        category: mappingData.category,
        order: mappingData.order,
        case: mappingData.case,
        dataType: mappingData.type,
        dateFormat: mappingData.dateFormat,
        date_category: mappingData.date_category,
        description: mappingData.description,
        required: mappingData.required,
        extract: mappingData.extract,
        extract_by_words: mappingData.extract_by_words,
        redact_field: mappingData.redact_field,
        show_field: mappingData.show_field,
        sensitive_data: mappingData.sensitive_data,
        key_alias: mappingData.key_alias,
        edit_type: 'created',
        uniq_id: Date.now().toString(),
        path: parentPath + '.' + this.pathCount
      })

      this.drawLayer.add(newShape)
      if (mappingData.order <= this.updatedNoOfMappings) {
        this.updateOrderForMappings(mappingData)
      }
      this.showNewMapping = false
      this.pathCount++

      this.updateMappingData()
      this.pushToHistory()
      this.updatedNoOfMappings += 1
    },

    mappingUpdated (mappingData, npiGroup, oldNpiGroup) {
      let updateShape = this.selectedShape(mappingData.path, mappingData.el_type)
      this.updateOrderForMappings(mappingData)
      updateShape.setAttrs({
        key: mappingData.key,
        category: mappingData.category,
        order: mappingData.order,
        case: mappingData.case,
        dataType: mappingData.type,
        description: mappingData.description,
        required: mappingData.required,
        extract: mappingData.extract,
        extract_by_words: mappingData.extract_by_words,
        show_field: mappingData.show_field,
        redact_field: mappingData.redact_field,
        sensitive_data: mappingData.sensitive_data,
        key_alias: mappingData.key_alias,
        dateFormat: mappingData.dateFormat,
        date_category: mappingData.date_category
      })

      if ((updateShape.attrs.dataType === 'npi' && updateShape.attrs.map_type === 'group')) {
        npiGroup['old_key'] = mappingData.originalKey
        let newNpiGroups = this.npiGroups.slice().filter((group) => {
          return group.npi_group_name !== mappingData.oldKey
        })
        this.npiGroups = [npiGroup].concat(newNpiGroups)
      }

      if ((updateShape.parent.attrs.dataType === 'npi' && updateShape.parent.attrs.map_type === 'group') || (updateShape.attrs.dataType === 'npi' && updateShape.attrs.map_type === 'group')) {
        updateShape.setAttrs({
          npi_group: npiGroup
        })
      }

      if (updateShape.attrs.map_type === 'group') {
        let groupShapes = this.shapesInGroup(updateShape)
        groupShapes.forEach((shape) => {
          let required = this.updateRequiredField(updateShape, shape)
          shape.setAttrs({
            required: required
          })
        })
      }

      mappingData.replacedNpiMappings.map((child) => {
        this.mappingsSaveData.map(previousMappings => {
          if (previousMappings.key === child) {
            previousMappings.path = previousMappings.path.split('.')[0] + '.' + previousMappings.path.split('.').pop()
          }
        })
      })

      if (mappingData.type === 'npi' && mappingData.el_type === 'Group') {
        var fields = Object.keys(npiGroup)
        fields.map((field) => {
          if (npiGroup[field] !== null && field !== 'npi_group_name' && field !== 'old_key') {
            this.mappingsSaveData.map(previousMappings => {
              if (previousMappings.key === npiGroup[field]) {
                previousMappings.path = mappingData.path + '.' + previousMappings.path.split('.').pop()
              }
            })
          }
        })
      }

      this.updateMappingData()
      this.pushToHistory()
      this.showEditMapping = false
    },

    mappingCancelled () {
      this.showNewMapping = false
      let invalidShape = this.creatingShape
      if (invalidShape) {
        invalidShape.destroy()
        this.tempLayer.draw()
      }
    },

    showEditNode (node) {
      if (node.type !== 'Layer') {
        let type = node.type === 'Group' ? 'Group' : 'Rect'
        this.editShape = this.drawLayer.find(type).filter(function (shape) {
          return shape.attrs.path === node.id
        })[0]
        this.showEditMapping = true
      }
    },

    updateCancelled () {
      this.showEditMapping = false
    },

    updateOrderForMappings (mappingData) {
      this.sortMappings()
      let parentKeyObj = this.getOrderIndex(this.drawLayer, mappingData) // gets the element selected for updation
      this.rearrangeTheMappings(this.drawLayer, parentKeyObj)
    },

    rearrangeTheMappings (drawLayer, parentKeyObj) {
      for (let i = 0; i < drawLayer.children.length; i++) {
        const child = drawLayer.children[i]
        if (child.attrs.parentKey === parentKeyObj.attrs.parentKey) {
          child.attrs.order = i + 1
        } else if (child.children) {
          this.rearrangeTheMappingsForChild(child, parentKeyObj)
        }
      }
    },

    rearrangeTheMappingsForChild (child, parentKeyObj) {
      for (let i = 1; i < child.children.length; i++) {
        const subChild = child.children[i]
        if (subChild.attrs.parentKey === parentKeyObj.attrs.parentKey) {
          subChild.attrs.order = i
        } else if (subChild.children) {
          this.rearrangeTheMappingsForChild(subChild, parentKeyObj)
        }
      }
    },

    sortMappings () {
      this.drawLayer.children.sort((a, b) => a.attrs.order - b.attrs.order)
      this.drawLayer.children.map((child) => {
        if (child.children) {
          child.children.sort((a, b) => a.attrs.order - b.attrs.order)
        }
      })
    },

    getOrderIndex (drawLayer, mappingData, type = 'parent') {
      let foundChild, movedOrder
      for (let i = 0; i < drawLayer.children.length; i++) {
        const child = drawLayer.children[i]
        if (child.attrs.key === mappingData.originalKey) {
          foundChild = child
          movedOrder = drawLayer.children.splice(i, 1)[0]
          if (type === 'child') {
            drawLayer.children.splice(mappingData.order, 0, movedOrder)
          } else {
            drawLayer.children.splice(mappingData.order - 1, 0, movedOrder)
          }
          break
        }
        if (child.children) {
          const found = this.getOrderIndex(child, mappingData, 'child')
          if (found) {
            foundChild = found
            break
          }
        }
      }
      return foundChild
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/templateMappings.js